import { IDualSelectItemList } from './ListItem.interfaces';
import ListItem from './ListItem';

export default ListItem as any as any as React.StatelessComponent<IDualSelectItemList>;
